// This hook keeps state of which modal is open on the publication map page.

import { useState } from "react";

// Existing modals
type PublicationMapModal = "add-layer" | "add-map" | "add-study-area";

export function usePublicationMapModals() {
  const [openModalType, setOpenModalType] = useState<PublicationMapModal | null>(null);

  const openAddLayerModal = () => setOpenModalType((modal) => modal ?? "add-layer");
  const openAddMapModal = () => setOpenModalType((modal) => modal ?? "add-map");
  const openAddStudyAreaModal = () => setOpenModalType((modal) => modal ?? "add-study-area");
  const closeModal = () => setOpenModalType(null);

  return {
    openModalType,
    closeModal,
    openAddLayerModal,
    openAddMapModal,
    openAddStudyAreaModal,
  };
}
